import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo } from 'react';
import { Map } from 'immutable';

const emptyMap = Map();

export const PrettyErrorContext = createContext({
  onErrorClose: null,
  inputErrors: emptyMap,
});

export const usePrettyErrorContext = () => useContext(PrettyErrorContext);

/**
 * Provides the PrettyError context (onErrorClose/inputErrors) to descendants.
 * Used directly (e.g. By Company.js/Contact.js) or via the legacy bridge in InputErrorDisplay.js.
 */
export const PrettyErrorProvider = ({ children, onErrorClose, inputErrors = emptyMap }) => {
  const value = useMemo(() => ({ onErrorClose, inputErrors }), [onErrorClose, inputErrors]);

  return <PrettyErrorContext.Provider value={value}>{children}</PrettyErrorContext.Provider>;
};

PrettyErrorProvider.propTypes = {
  children: PropTypes.node,
  inputErrors: PropTypes.instanceOf(Map),
  onErrorClose: PropTypes.func,
};
